import path from "path-browserify";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ConfirmDelete from "./ConfirmDelete";
import { useDelete } from "../../hooks";
import { useTranslation } from "react-i18next";
import { BsPrinter } from "react-icons/bs";

export const Action = ({
  id,
  item1,
  path1,
  item2,
  path2,
  item3,
  icon1,
  icon2,
  icon3,
  refreshHandler,
}) => {
  const [t] = useTranslation("global");
  const navigate = useNavigate();
  const params = useParams();
  const [onShow, setOnShow] = useState(false);
  const { deleteItem, loading, data } = useDelete();

  const showModal = () => setOnShow(true);

  React.useEffect(() => {
    if (data) {
      refreshHandler();
    }
  }, [data]);

  return (
    <>
      <ConfirmDelete
        setOnShow={setOnShow}
        onShow={onShow}
        msg={t("Validate.confirm-del-bond")}
        onDeleteHandler={async () => {
          try {
            await deleteItem(
              `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/incomes/${id}`
            );
            setOnShow(false);
          } catch (error) {
            console.error("Error deleting item:", error);
          }
        }}
        loading={loading}
      />

      <div className="flex items-center justify-end ">
        <button
          onClick={() => navigate(`/${params.tenant}${path1}/${id}`)}
          className="flex items-center justify-center text-slate-800 text-sm p-2 rounded-md hover:bg-slate-100 transition-all"
        >
          {String(icon1 || "").includes("Print.png") ? (
            <BsPrinter className="text-[17px] text-[#261759]" />
          ) : (
            <img src={icon1} alt="" srcSet="" className="w-5" />
          )}

          <span className="ml-2">{item1}</span>
        </button>

        <button
          onClick={() => navigate(`/${params.tenant}${path2}/${id}`)}
          className="flex items-center text-slate-800 text-sm p-2 rounded-md hover:bg-slate-100 transition-all"
        >
          <img src={icon2} alt="" srcSet="" className="w-4" />
          <span className="ml-2">{item2}</span>
        </button>

        <button
          onClick={showModal}
          className="flex items-center text-red-600 text-sm p-2 rounded-md hover:bg-slate-100 transition-all"
        >
          <img src={icon3} alt="" srcSet="" className="w-4" />
          <span className="ml-2">{item3}</span>
        </button>
      </div>
    </>
  );
};
